import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { API_URL, getValFromLS } from "../helpers";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Td = ({ data }) => {
	return (
		<td
			className={
				data.text === "Donated"
					? "left success"
					: data.status === 1
					? "left success"
					: data.status === 0
					? "left error"
					: data.status === 2
					? "left working"
					: data.status === 4 || data.status === 5
					? "left notice"
					: "left working"
			}
		>
			<div className="flex">
				<i
					className={
						data.text === "Donated"
							? "fa fa-check-circle"
							: data.status === 1
							? "fa fa-check-circle"
							: data.status === 0
							? "fa fa-times-circle"
							: data.status === 2
							? "fa fa-hourglass-o"
							: data.status === 4
							? "fa fa-clock-o"
							: "fa fa-info-circle"
					}
				/>
				<span style={{ paddingBottom: "2px" }}>{data.text}</span>
			</div>
		</td>
	);
};

const StatusesGolf = ({ success, data }) => {
	const [msg, setMsg] = useState({});
	const formElement = useRef(null);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardStatuses`);
		let formData = new FormData(formElement.current);
		formData.append("event", data.id);
		formData.append("auth", getValFromLS("dash", true));
		formData.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({});
				success(json.text);
			} else {
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<form
			ref={formElement}
			method="post"
			action="/"
			onSubmit={(e) => handleSubmit(e)}
			style={{ marginTop: "35px" }}
		>
			<table className="approved assigned">
				<thead>
					<tr>
						<th colSpan="4" className="hdg">
							{`${data.name} Guests Status`}
						</th>
					</tr>
					<tr className={data.groups[0] === "0" ? "hidden" : ""}>
						<td className="left">Guest Name</td>
						<td className="center" style={{ width: "15%" }}>
							Group Number
						</td>
						<td className="center" style={{ width: "21%" }}>
							Status
						</td>
						<td className="center" style={{ width: "21%" }}>
							Registration Complete
						</td>
					</tr>
				</thead>
				{data.guests.length > 0 ? (
					<tbody>
						{data.guests.map((item) => {
							return (
								<tr key={item.guestId}>
									<td className="left">
										{item.name === "donated" ? (
											<span className="working">Donated Back</span>
										) : (
											<span>
												<Link to={`/dashboard/guest/${item.id}`}>
													{item.name}
												</Link>
											</span>
										)}
									</td>
									<td className="center">
										<select
											name={`guestId[${item.guestId}]`}
											className="form-control"
											placeholder=""
											autoComplete="off"
											style={{
												display: "inline-block",
												paddingLeft: "5px",
												width: "50px",
											}}
											defaultValue={item.groupNumber}
										>
											{data.groups.map((group) => {
												return (
													<option key={group} value={group}>
														{group}
													</option>
												);
											})}
										</select>
									</td>
									<Td
										data={{
											status: item.attention ? 5 : item.status,
											text: item.text,
										}}
									/>
									<td className="center">
										{item.name === "donated" ? (
											<span className="working">-</span>
										) : item.attention ? (
											<i
												className="fa fa-exclamation-circle notice"
												style={{
													fontSize: "1.25rem",
													paddingLeft: "0",
													paddingTop: "5px",
												}}
											/>
										) : (
											<i
												className="fa fa-check-circle success"
												style={{
													fontSize: "1.25rem",
													paddingLeft: "0",
													paddingTop: "5px",
												}}
											/>
										)}
									</td>
								</tr>
							);
						})}
					</tbody>
				) : (
					<tbody>
						<tr>
							<td
								className="center"
								colSpan="4"
								style={{ paddingTop: "15px", paddingBottom: "15px" }}
							>
								<span className="working">
									{data.groups[0] === "0"
										? " -- Not participating in this event --"
										: " -- No guests statuses found --"}
								</span>
							</td>
						</tr>
					</tbody>
				)}
			</table>

			{data.guests.length > 0 && (
				<div className="msg-submit">
					{msg.type && <Msg data={msg} />}

					<div
						className={
							msg.type === "working" || msg.type === "success"
								? "hidden"
								: "submit-container"
						}
					>
						<Submit submit="Update Group Assignments" />
					</div>
				</div>
			)}
		</form>
	);
};

export default StatusesGolf;
